import { useState, ReactElement } from "react";
import Modalui from "src/components/UI/modal/Modalui";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Tooltip } from "@mui/material";
import { initialSubsDetail, SubscriptionAttributes, SubsList } from "src/page/plans/plansSlice";
import SubscriptionPlanCard from "../SubscriptionCard/SubscriptionPlanCard";
import styles from "./planPreviewModal.module.scss";

interface PlanPreviewModalProps {
  title: string;
  subTitle: string;
  description: string;
  category: string;
  attributes?: SubscriptionAttributes;
  icon?: ReactElement;
}

export default function PlanPreviewModal({
  title,
  subTitle,
  description,
  icon,
  category,
  attributes
}: PlanPreviewModalProps) {
  const [preview, setPreview] = useState<boolean>(false);

  const previewSubscription: SubsList = {
    ...initialSubsDetail,
    title,
    subTitle,
    description,
    subscription_category: category as SubsList["subscription_category"],
    attributes: attributes ?? initialSubsDetail.attributes
  };

  return (
    <>
      <Modalui open={preview} handleClose={() => setPreview(false)} modaluiOver={styles.previewModalOver}>
        <div className={styles.previewModalContainer}>
          <SubscriptionPlanCard subscription={previewSubscription} hideSelectButton />
        </div>
      </Modalui>
      <div
        onClick={() => setPreview(true)}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Tooltip title="Preview" placement="top" arrow>
          {icon || <VisibilityOutlinedIcon aria-label="preview plan" />}
        </Tooltip>
      </div>
    </>
  );
}
